/* import __COLOCATED_TEMPLATE__ from './market-select-with-add-new.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { v4 as uuidv4 } from 'uuid';
import { scheduleOnce, next } from '@ember/runloop';
function localeAndCaseAgnosticSort(arr) {
  return arr.sort((a, b) => Intl.Collator().compare(a.label, b.label));
}
let MultiselectWithAddNew = (_class = class MultiselectWithAddNew extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "searchText", _descriptor2, this);
    _initializerDefineProperty(this, "isOptionsLazyRendered", _descriptor3, this);
    _initializerDefineProperty(this, "uuid", _descriptor4, this);
  }
  get options() {
    return localeAndCaseAgnosticSort(this.args.options);
  }
  get selectedOptions() {
    return this.args.selectedOptions?.join(',');
  }
  get shouldRenderAllOptions() {
    if (!this.args.shouldLazyRenderOptions) {
      return true;
    }
    return this.isOptionsLazyRendered;
  }
  handleDidInsert() {
    if (!this.args.shouldLazyRenderOptions) {
      return;
    }
    scheduleOnce('afterRender', this, this.setIsOptionsLazyRendered);
  }
  setIsOptionsLazyRendered() {
    this.isOptionsLazyRendered = true;
  }
  onSearchValueChange(event) {
    this.searchText = event.detail.current;
  }
  onAddNewClick() {
    if (this.searchText) {
      const selectedOptionsLength = this.args.selectedOptions?.length || 0;
      const searchText = this.searchText;
      this.args.onAddNewClick && this.args.onAddNewClick(this.searchText);
      const marketInputSearch = document.querySelector(`[market-select-with-add-new-search="${this.uuid}"]`);
      marketInputSearch?.clearInput();

      // https://github.com/squareup/dashboard/pull/78778#discussion_r1752431061
      next(() => {
        if (selectedOptionsLength > 0) {
          return;
        }
        const newAddedOptionSelector = `[data-test-market-select-with-add-new-options="${searchText}-${this.uuid}"]`;
        const newAddedOption = document.querySelector(newAddedOptionSelector);
        newAddedOption?.click();
      });
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "searchText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isOptionsLazyRendered", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "uuid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return uuidv4();
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleDidInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDidInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsOptionsLazyRendered", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsOptionsLazyRendered"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSearchValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSearchValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAddNewClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAddNewClick"), _class.prototype), _class);
export { MultiselectWithAddNew as default };